import dayjs from 'dayjs'
import localeData from 'dayjs/plugin/localeData'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import i18n, { InitOptions } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { marketplacePublicUrl } from 'app-config'
import { FEATURES } from 'utils/features'

dayjs.extend(localeData)
dayjs.extend(localizedFormat)

export const defaultLng = FEATURES.defaultLanguage
export const defaultNS = 'common'
export const nsSeparator = '|'

// Only an explicit valid stored preference wins; anything else (missing or
// unrecognised) falls back to the region default. Pure read — no side effects.
export const getDefaultLanguage = (): 'en' | 'zh' => {
  const stored = typeof localStorage === 'undefined' ? null : localStorage.getItem('i18nDefaultLng')
  return stored === 'en' || stored === 'zh' ? stored : defaultLng
}

export const createI18nConfig = (lng?: string): InitOptions => ({
  ...(lng ? { lng } : {}),
  // Missing-key fallback stays English in every jurisdiction (raw keys must never
  // render); the jurisdiction default language is applied by LocalisationProvider
  fallbackLng: 'en',
  ns: [],
  defaultNS,
  fallbackNS: defaultNS,
  nsSeparator,
  load: 'languageOnly',
  backend: {
    loadPath: `${marketplacePublicUrl}locales/{{lng}}/{{ns}}.json`,
  },
})

export const createi18n = (lng?: string) =>
  i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init(createI18nConfig(lng))
export default i18n
